/* eslint-disable require-jsdoc */

export default function selectGlobalFields({ globalFields }) {
    return globalFields;
}
